// oxlint-disable-next-line no-restricted-imports
import { fromJS, List, Map, Record } from '@gonfalon/immutable-shim/immutableShim';
import type { CreateFunctionInput } from '@gonfalon/legacy-immutable/immutableUtils';

import { EnvironmentSettings } from '#utils/flags/records/EnvironmentSettings';
import { createGoal, Goal } from '#utils/goalUtils';

type ExperimentProps = {
  metricKey: string;
  _metric: Goal;
  environments: List<string>;
  _environmentSettings: Map<string, EnvironmentSettings>;
};

export class Experiment extends Record<ExperimentProps>({
  metricKey: '',
  _metric: new Goal(),
  environments: List(),
  _environmentSettings: Map(),
}) {
  toRep() {
    return fromJS(this.toJSON()).withMutations((map: Experiment) => {
      map.delete('_metric');
      map.delete('_environmentSettings');
    });
  }
}

export function createExperiment(props?: CreateFunctionInput<Experiment>) {
  return createExperimentItem(props);
}

export function createExperimentItem(props?: CreateFunctionInput<Experiment>) {
  return new Experiment(fromJS(props))
    .update('_metric', (m) => createGoal(m))
    .update('_environmentSettings', (es) => es.map((v) => new EnvironmentSettings(v)));
}
